import http_request from '../http_request'
import config from 'config'

function sharePair(device_uid, slide, try_count, match_count, headers) {
	return http_request.post(config.hub + 'datasync/matchingpairs')
		.withHeaders(headers)
		.send({
			device_uid,
			slide,
			try_count,
			match_count,
		})
}

export default sharePair
